import { render, staticRenderFns } from "./terminos-y-condiciones.vue?vue&type=template&id=3d294090"
import script from "./terminos-y-condiciones.vue?vue&type=script&lang=js"
export * from "./terminos-y-condiciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports